<template>
  <div class="flex flex-col items-end w-[1.5rem]" v-if="canZoom">
    <div class="text-center w-full" style="font-size: 0.8em;">
      {{ RangeZoom[value] }}x
    </div>
    <div class="wrapper-zoom">
      <input @change="editZoom()" type="range" min="0" :max="RangeZoom.length - 1" v-model="value" step="1"
        :id="`inputZoom_${video.dvv_id}`" />
    </div>
  </div>

</template>
<script>
import { ref } from "vue";
import API from "@/utils/API.js";

export default {
  name: "Zoom",
  components: {
  },
  props: {
    config: Object,
    video: Object,
  },
  setup() {
    return {
      zoom: ref([2, 5, 10, 20, 50, 100, 200]),
      ir: ref([2, 5, 10, 20]),
      RangeZoom: ref([2, 5, 10, 20, 50, 100, 200]),
      value: ref(0),
      currentZoom: ref(null),
    };
  },

  mounted() {
    this.zoomValue();
  },

  methods: {

    async editZoom() {
      let data = await API.put(`camerafocallengthset`, {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
        CamType: this.config.camera.status.video_type,
        Factor: this.RangeZoom[this.value],
      });

      // this.$root.msg_replie[data.command] = {
      //   id: data.command,
      //   name: "Changement focal",
      // };
    },

    zoomValue() {
      if (this.config?.camera?.status?.video_type == 'ir') {
        this.currentZoom = 'ir';
        this.RangeZoom = this.ir;
        this.setValue(this.config?.camera?.status?.ir_zoom_factor);
      }
      else if (this.config?.camera?.status?.video_type == 'zoom') {
        this.currentZoom = 'zoom';
        this.RangeZoom = this.zoom;
        this.setValue(this.config?.camera?.status?.zoom_factor);
      }
    },

    setValue(value) {
      let index = this.indexPlusProche(value, this.RangeZoom);
      if (index != -1) {
        this.value = index;
      }
    },

    indexPlusProche(valeur, tableau) {
      let indexProche = 0;
      let differenceMin = Math.abs(valeur - tableau[0]);

      for (let i = 1; i < tableau.length; i++) {
        let difference = Math.abs(valeur - tableau[i]);
        if (difference < differenceMin) {
          differenceMin = difference;
          indexProche = i;
        }
      }

      return indexProche;
    }


  },

  computed: {
    canZoom() {
      return this.config?.camera?.status?.video_type == 'ir' || this.config?.camera?.status?.video_type == 'zoom';
    },
  },

  watch: {
    'config.camera.status.video_type': {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.zoomValue();
        }
      },
      deep: true,
    },

    'config.camera.status.ir_zoom_factor': {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.setValue(val);
        }
      },
      deep: true,
    },

    'config.camera.status.zoom_factor': {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.setValue(val);
        }
      },
      deep: true,
    },
  }
};
</script>
